import { Box, keyframes } from '@mui/material';

const rotate = keyframes`
  0% { transform: rotate(0deg); }
  25% { transform: rotate(90deg); }
  50% { transform: rotate(180deg); }
  75% { transform: rotate(270deg); }
  100% { transform: rotate(360deg); }
`;

const pulse = keyframes`
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.5; transform: scale(0.85); }
`;

interface SpinnerIconProps {
    size?: number;
    color?: string;
}

const SpinnerIcon = ({ size = 48, color = '#6366f1' }: SpinnerIconProps) => (
    <Box
        sx={{
            position: 'relative',
            width: size,
            height: size,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
    >
        {/* Outer rotating square */}
        <Box
            sx={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                border: '4px solid',
                borderColor: color,
                animation: `${rotate} 1.2s steps(4, end) infinite`,
            }}
        />
        {/* Inner pulsing square */}
        <Box
            sx={{
                width: '50%',
                height: '50%',
                backgroundColor: color,
                animation: `${pulse} 0.6s ease-in-out infinite`,
            }}
        />
    </Box>
);

export default SpinnerIcon;
